import type React from 'react';
import omniiq_logo from '../assets/omniiq_logo.png';

const OmniCleanAirLogo: React.FC = () => {
  return (
    <div className="flex-shrink-0">
      <img 
        className="h-8 w-auto" 
        src={omniiq_logo} 
        alt="OmniIQ Logo" 
      />
    </div>
  );
};

export default OmniCleanAirLogo;
